import { useState, useEffect, useCallback, ChangeEvent, act } from 'react'
import { FilterDefinition, getFilters, SelectedFilter } from '../api/dashboard';
export enum SelectionAction {
    Add,
    Remove,
    Change
}
export interface DropDownOption {
    label: string;
    value: string;
}
export interface SelectionChangeEvent {
    action: SelectionAction,
    name: string,
    value: string

}
interface FilterProps {
    selected: SelectedFilter[],
    filterDefinitions: FilterDefinition[] | null
    onSelectionChange: (event: SelectionChangeEvent) => any
}
const Filter = ({ selected, filterDefinitions, onSelectionChange }: FilterProps) => {
    const [activeValue, setActiveValue] = useState<string>("");



    const handleDateChange = (event: ChangeEvent<HTMLInputElement>, type: string) => {
        onSelectionChange({ action: SelectionAction.Change, name: type, value: event.currentTarget.value })
    }
    const add = () => {
        onSelectionChange({ action: SelectionAction.Add, name: activeValue, value: "" });
        setActiveValue("");

    };
    const remove = (item: SelectedFilter) => {
        onSelectionChange({ action: SelectionAction.Remove, name: item.name, value: "" })
    };
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            const v = event.currentTarget.value;
            setActiveValue(v);

        }
    }
    const handleSubChange = (event: ChangeEvent<HTMLSelectElement>, selected: SelectedFilter) => {
        onSelectionChange({ action: SelectionAction.Change, name: selected.name, value: event.currentTarget.value })
    }
    const startDate = selected.find(i => i.name == "StartDate");
    const endDate = selected.find(i => i.name == "EndDate");
    return (
        <div className="mb-4">
            <h2>Struck-By Incident Reports Data</h2>
            <div className="row">
                <div className='col-50 col-s-100 border-solid border-current border-1 mt-2'>
                    <h2 className='h6'>Start Date</h2>
                    <input type="date" onChange={(event => handleDateChange(event, "StartDate"))} value={startDate?.value} />
                </div>
                <div className='col-50 col-s-100 border-solid border-current border-1 mt-2'>
                    <h2 className='h6'>End Date</h2>
                    <input type="date" onChange={(event => handleDateChange(event, "EndDate"))} value={endDate?.value} />
                </div>
            </div>
            {filterDefinitions?.map(function (item, index) {
                const filter = selected?.find(i => i.name == item.id);

                if (!filter) {
                    return null;
                }
                return (<div className='border-solid border-current border-1 mt-4' key={index}>
                    <h3 className='h6'>{item.name}</h3>
                    <select onChange={(event) => handleSubChange(event, filter)} defaultValue={filter.value} className="mb-4 px-4">
                        <option value="">-Select {item.name}-</option>
                        {item.values?.map(function (item, optionIndex) {
                            return (<option value={item} key={optionIndex}>{item}</option>);
                        }
                        )}
                    </select>
                    <button onClick={() => remove(filter)} className="button">Remove Filter</button>
                </div>);
            })}
            <div className="mt-2">
                <h2 className='h6'>Choose Incident Characteristics Filters</h2>
                <select onChange={(event) => handleChange(event)} className="mb-4 px-4">
                    <option value="">-Select Filter-</option>
                    {filterDefinitions?.map(function (item, index) {
                        if (selected?.some(i => i.name == item.id)) {
                            return null;
                        }
                        return (<option value={item.id} key={index}>{item.name}</option>);
                    }
                    )}
                </select>
                <button onClick={add} className="button">Add Filter</button>
            </div>
        </div>
    );
}
export default Filter;